import React, { useState, useEffect, useCallback } from "react";
import { getLoggedInUser } from "../helpers";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { Container, Col, Row, Label, Alert } from "reactstrap";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import { connect } from "react-redux";
import { betSlipService } from "../redux/betslip/services";
import swal from "sweetalert";
import Loader from "../components/Loader/Loader";
import config from "react-global-configuration";
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-input-2/lib/style.css";
import "../assets/scss/_common.scss";

import { useTranslation } from "react-i18next";
// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css';
import 'react-phone-number-input/style.css'
import PhoneInput from "react-phone-input-2";
// import PhoneInput from 'react-phone-number-input'

const EditAccounts = (props) => {
  const [user, setUser] = useState(getLoggedInUser());
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [userList, setUserList] = useState({ phone: "" });
  const [isEditable, setIsEditable] = useState(true);
  const [value, setValue] = useState('');
  const [emailChecked, setEmailChecked] = useState(1);
  const [smsChecked, setSmsChecked] = useState(1);
  const [phoneChecked, setPhoneChecked] = useState(1);
  const [postChecked, setPostChecked] = useState(1);
  const [countryInfo, setCountryInfo] = useState({
    name: 'India',
    code: 'IN',
    flag: '🇮🇳',
    dialCode: '+91'
  });




  //  const dob = userList?.dob ? new Date(userList.dob) : null;


  let dob = null;
  if (userList?.dob) {
    const parts = userList.dob.split("-");

    if (parts.length === 3) {
      // Check format: DD-MM-YYYY
      if (parts[0].length === 2) {
        dob = new Date(parts[2], parts[1] - 1, parts[0]);
      } else {
        // Format: YYYY-MM-DD
        dob = new Date(parts[0], parts[1] - 1, parts[2]);
      }
    }
  }


  const loadRecordsTables = useCallback(() => {
    setIsLoading(true);
    const reqData = { guid: user.guid };
    betSlipService
      .fatchUserDetails(reqData)
      .then((res) => {
        let data = res.data;
        setUserList(data);
        setValue(data?.phone || "");
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [user.guid]);

  useEffect(() => {
    loadRecordsTables();
  }, [loadRecordsTables]);
  const navigate = useNavigate();
  const handleValidSubmit = (event, values) => {
    setIsLoading(true);
    const dobString = `${values.day}-${values.month}-${values.year}`;

    let formData = new FormData();
    formData.append("guid", values?.guid);
    formData.append("first_name", values?.first_name);
    formData.append("last_name", values?.last_name);
    formData.append("nick_name", values?.nick_name);
    // formData.append("street_number", values?.street_number);
    // formData.append("basic_info", values?.basic_info);
    formData.append("email", values?.email);
    formData.append("gender", values?.gender);
    // formData.append("phone", values?.phone);
    // formData.append("phone", value );
    formData.append("phone", value ?? userList?.phone ?? "");
    formData.append("country", values?.country);
    formData.append("city", values?.city);
    // formData.append("currency", values?.currency);
    formData.append("address", values?.address);
    formData.append("post_code", values?.post_code);
    formData.append("date_of_birth", dobString);
    formData.append("email_promotion", true);
    formData.append("sms_promotion", true);
    formData.append("phone_promotion", true);
    formData.append("post_promotion", true);


    console.log("Final date sent to API:", dobString);


    betSlipService
      .updateUserDetails(formData, config)
      .then((res) => {
        navigate("/user-profile");
        setIsLoading(false);
        setIsEditable(false);
        swal(res?.message, {
          icon: "success",
        });
      })
      .catch((error) => {
        setIsLoading(false);
        swal(error.message, {
          icon: "error",
        });
      });
  };

  const handleValidSubmitdate = (event, values) => {
    props.registerUser(values);
  };

  const handlePhoneChange = (value) => {
    setUserList((prevList) => ({
      ...prevList,
      phone: value,
    }));
  };

  const onTrigger = () => {
    if (props.parentCallback) {
      props.parentCallback(true); // Triggers setSlidebar(true) in parent
    }
  };

  const onChangeFile = (event) => {
    event.preventDefault();
    let file = event.target.files[0];

    let formData = new FormData();
    formData.append("guid", user.guid);
    formData.append("profile_img", file, file.name);
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    betSlipService
      .updateUserProfile(formData, config)
      .then((res) => {
        setIsLoading(false);
        swal(res.message, {
          icon: "success",
        });
        loadRecordsTables();
      })
      .catch((error) => {
        setIsLoading(false);
        swal(error.message, {
          icon: "error",
        });
      });
  };

  let loadingComponent = isLoading ? <Loader /> : null;

  return (
    <React.Fragment>
      {props.error && (
        <Alert color="danger" isOpen={props.error ? true : false}>
          <div dangerouslySetInnerHTML={{ __html: props.error }}></div>
        </Alert>
      )}

      {
        <div className="account-pages ">
          <section className="account-section account-section-profile overflow-hidden bg_img_login img">
            <Container>
              <div className="profile-edit-wrapper">
                <Row className="justify-content-center gy-5">
                  <Col className="col-xl-12">
                    <div className="user-toggler-wrapper d-flex align-items-center d-lg-none">
                      <h4 className="title m-0">Menu</h4>
                      <div className="user-toggler" onClick={() => onTrigger()}>
                        <i className="las la-sliders-h"></i>
                      </div>
                    </div>
                    <div className="custom--card card--lg">
                      <div className="card--body">
                        <AvForm onValidSubmit={handleValidSubmit}>
                          <Row className="">
                            <AvField
                              type="hidden"
                              name="guid"
                              id="guid"
                              value={userList ? userList.guid : ""}
                            />

                            <div className="col-md-6">
                              <div className="outer">
                                {" "}
                                <h1 className="personal">{t('userProfile.profilePage.personal')}</h1>
                              </div>

                              <div className="form-group">
                                <label for="fname" className="form-label">
                                  {t('userProfile.profilePage.firstName')}{" "}
                                </label>
                                <AvField
                                  id="fname"
                                  type="text"
                                  className="form-control form--control3 style-two "
                                  name="first_name"
                                  placeholder="Enter first name"
                                  required
                                  errorMessage="Please enter your first name."
                                  value={userList ? userList.first_name : ""}
                                  // disabled={!!userList.first_name}
                                  disabled={!isEditable || !!userList?.first_name}
                                // disabled
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="outer">
                                <h1 className="personal">{t('userProfile.profilePage.location')}</h1>
                              </div>
                              <div className="form-group">
                                <label for="fname" className="form-label">
                                  {t('userProfile.profilePage.streetNumber')}
                                </label>
                                <AvField
                                  id="address"
                                  type="text"
                                  className="form-control form--control3 style-two "
                                  name="address"
                                  placeholder="Enter Street and Number"
                                  required
                                  errorMessage="Please enter your Street and Number."
                                  value={userList ? userList.address : ""}
                                  // disabled={!!userList.address}
                                  disabled={!isEditable || !!userList?.address}
                                // disabled
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label for="fname" className="form-label">
                                  {t('userProfile.profilePage.lastName')}
                                </label>
                                <AvField
                                  id="lname"
                                  type="text"
                                  className="form-control form--control3 style-two "
                                  name="last_name"
                                  placeholder="Enter Last name"
                                  required
                                  errorMessage="Please enter your Last name."
                                  value={userList ? userList.last_name : ""}
                                  disabled={!isEditable || !!userList?.last_name}
                                //  disabled={!!userList.last_name}
                                // disabled
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label for="city" className="form-label">
                                  {t('userProfile.profilePage.city')}
                                </label>
                                <AvField
                                  required
                                  errorMessage="Please enter your city ."
                                  type="text"
                                  name="city"
                                  placeholder="Enter City"
                                  value={userList ? userList.city : ""}
                                  // disabled={!!userList.city}
                                  disabled={!isEditable || !!userList?.city}
                                  className="form-control form--control3 style-two"
                                >
                                  {/* <option value="">Please select city</option>
                                  <option value="New York">New York</option>
                                  <option value="Los Angeles">
                                    Los Angeles
                                  </option>
                                  <option value="London">London</option>
                                  <option value="Paris">Paris</option>
                                  <option value="Berlin">Berlin</option>
                                  <option value="Tokyo">Tokyo</option>
                                  <option value="Delhi">Delhi</option>
                                  <option value="Mumbai">Mumbai</option>
                                  <option value="Toronto">Toronto</option>
                                  <option value="Sydney">Sydney</option>
                                  <option value="Melbourne">Melbourne</option>
                                  <option value="Dubai">Dubai</option>
                                  <option value="Singapore">Singapore</option>
                                  <option value="Cairo">Cairo</option>
                                  <option value="Bangkok">Bangkok</option>
                                  <option value="Moscow">Moscow</option>
                                  <option value="Madrid">Madrid</option>
                                  <option value="Rome">Rome</option>
                                  <option value="Beijing">Beijing</option>
                                  <option value="Seoul">Seoul</option> */}
                                </AvField>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label for="email" className="form-label">
                                  {t('userProfile.profilePage.email')}

                                  {/* <span style={{color:"#F56464"}}>*</span> */}
                                </label>
                                <AvField
                                  id="email"
                                  type="email"
                                  className="form-control form--control3 style-two "
                                  name="email"
                                  placeholder="Enter email"
                                  required
                                  value={userList ? userList.email : ""}
                                  disabled={!isEditable || !!userList?.email}
                                //  disabled={!!userList.email}
                                // disabled
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">

                                {/* <AvField
                                  required
                                  type="date"
                                 
                                  name="date_of_birth"
                                  className="form-control form--control3 style-two"
                                  value={userList?.dob}
                                    disabled={!!userList.dob}
                                  errorMessage="Please select your date of birth."
                                  validate={{
                                    required: {
                                      value: true,
                                      errorMessage: "Date of birth is required",
                                    },
                                    validAge: (value) => {
                                      if (!value) return false;
                                      const today = new Date();
                                      const birthDate = new Date(value);
                                      const eighteenYearsAgo = new Date(
                                        today.getFullYear() - 18,
                                        today.getMonth(),
                                        today.getDate()
                                      );

                                      return birthDate <= eighteenYearsAgo
                                        ? true
                                        : "You must be at least 18 years old.";
                                    }
                                  }}
                                /> */}


                                <div className="date-outer">
                                  {/* <label htmlFor="date_of_birth" className="form-label">
                                  Date of Birth
                                </label> */}
                                  <div className="date-css">

                                    {/* Day */}
                                    <div className="col-md-4 p-0">
                                      <AvField
                                        type="select"
                                        name="day"
                                        label={t('userProfile.profilePage.day')}
                                        className="form-control form--control3 style-two"
                                        value={dob ? String(dob.getDate()).padStart(2, "0") : ""}
                                        // disabled={!!userList.dob}
                                        disabled={!isEditable || !!userList?.dob}
                                        required
                                        errorMessage="Day is required"
                                      >
                                        <option value="">DD</option>
                                        {Array.from({ length: 31 }, (_, i) => {
                                          const day = String(i + 1).padStart(2, "0");
                                          return (
                                            <option key={day} value={day}>
                                              {day}
                                            </option>
                                          );
                                        })}
                                      </AvField>
                                    </div>

                                    {/* Month */}
                                    <div className="col-md-4 p-0">
                                      <AvField
                                        type="select"
                                        name="month"
                                        label={t('userProfile.profilePage.month')}
                                        className="form-control form--control3 style-two"
                                        value={dob ? String(dob.getMonth() + 1).padStart(2, "0") : ""}
                                        // disabled={!!userList.dob}
                                        disabled={!isEditable || !!userList?.dob}
                                        required
                                        errorMessage="Month is required"
                                      >
                                        <option value="">MM</option>
                                        {Array.from({ length: 12 }, (_, i) => {
                                          const month = String(i + 1).padStart(2, "0");
                                          return (
                                            <option key={month} value={month}>
                                              {month}
                                            </option>
                                          );
                                        })}
                                      </AvField>
                                    </div>

                                    {/* Year */}
                                    <div className="col-md-4 p-0">
                                      <AvField
                                        type="select"
                                        name="year"
                                        label={t('userProfile.profilePage.year')}
                                        className="form-control form--control3 style-two"
                                        value={dob ? String(dob.getFullYear()) : ""}
                                        // disabled={!!userList.dob}
                                        disabled={!isEditable || !!userList?.dob}
                                        // required
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage: "Year is required",
                                          },
                                          validAge: (value, ctx) => {
                                            const { day, month } = ctx;
                                            if (!day || !month || !value) return false;

                                            const birthDate = new Date(value, month - 1, day);
                                            const today = new Date();
                                            const eighteenYearsAgo = new Date(
                                              today.getFullYear() - 18,
                                              today.getMonth(),
                                              today.getDate()
                                            );

                                            return birthDate <= eighteenYearsAgo
                                              ? true
                                              : "You must be at least 18 years old.";
                                          },
                                        }}
                                      >
                                        <option value="">YYYY</option>
                                        {Array.from(
                                          { length: 100 },
                                          (_, i) => new Date().getFullYear() - i
                                        ).map((year) => (
                                          <option key={year} value={year}>
                                            {year}
                                          </option>
                                        ))}
                                      </AvField>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label for="gender" className="form-label">
                                  {t('userProfile.profilePage.gender')}
                                </label>
                                <AvField
                                  required
                                  errorMessage="Please select a gender option."
                                  type="select"
                                  name="gender"
                                  value={userList?.gender}
                                  disabled={!isEditable || !!userList?.gender}
                                  // disabled={!!userList.gender}
                                  className="form-control form--control3 style-two "
                                >
                                  <option value="">Gender</option>
                                  <option value="male">Male</option>
                                  <option value="female">Female</option>
                                  <option value="other">Other</option>
                                </AvField>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label for="post_code" className="form-label">
                                  {t('userProfile.profilePage.zipCode')}
                                </label>
                                <AvField
                                  required
                                  errorMessage="Please enter your postal code."
                                  id="post_code"
                                  type="text"
                                  className="form-control form--control3 style-two"
                                  name="post_code"
                                  placeholder="Enter postal code"
                                  value={userList ? userList.post_code : ""}
                                  disabled={!isEditable || !!userList?.post_code}
                                // disabled={!!userList.post_code}

                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label for="nick_name" className="form-label">
                                  {t('userProfile.profilePage.nickName')}
                                </label>
                                <AvField
                                  id="nick_name"
                                  type="text"
                                  className="form-control form--control3 style-two "
                                  name="nick_name"
                                  placeholder="Enter nick name"
                                  required
                                  value={userList ? userList.nick_name : ""}
                                  // disabled={!!userList.nick_name}
                                  disabled={!isEditable || !!userList?.nick_name}
                                // disabled
                                />
                              </div>
                            </div>
                            <div className="col-md-6 d-none">
                              <div className="form-group">
                                {/* <label for="phone" className="form-label">
                                  Phone Number
                                </label>
                                <AvField
                                  id="phone"
                                  type="number"
                                  className="form-control form--control style-two "
                                  name="phone"
                                  placeholder="Enter your phone no"
                                  value={userList ? userList.phone : ""}
                                /> */}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label for="country" className="form-label">
                                  {t('userProfile.profilePage.country')}
                                </label>
                                <AvField
                                  required
                                  errorMessage="Please select a country option."
                                  type="select"
                                  name="country"
                                  // placeholder="Enter Country"
                                  value={userList ? userList.country : ""}
                                  disabled={!isEditable || !!userList?.country}
                                  // disabled={!!userList.country}
                                  className="form-control form--control3 style-two"
                                >
                                  <option value="">
                                    Please select country
                                  </option>
                                  <option
                                    value="Malta"
                                    className="malta-default"
                                  >
                                    Malta
                                  </option>
                                  <option value="Afghanistan">
                                    Afghanistan
                                  </option>
                                  <option value="Åland Islands">
                                    Åland Islands
                                  </option>
                                  <option value="Albania">Albania</option>
                                  <option value="Algeria">Algeria</option>
                                  <option value="American Samoa">
                                    American Samoa
                                  </option>
                                  <option value="Andorra">Andorra</option>
                                  <option value="Angola">Angola</option>
                                  <option value="Anguilla">Anguilla</option>
                                  <option value="Antarctica">Antarctica</option>
                                  <option value="Antigua and Barbuda">
                                    Antigua and Barbuda
                                  </option>
                                  <option value="Argentina">Argentina</option>
                                  <option value="Armenia">Armenia</option>
                                  <option value="Aruba">Aruba</option>
                                  <option value="Australia">Australia</option>
                                  <option value="Austria">Austria</option>
                                  <option value="Azerbaijan">Azerbaijan</option>
                                  <option value="Bahamas">Bahamas</option>
                                  <option value="Bahrain">Bahrain</option>
                                  <option value="Bangladesh">Bangladesh</option>
                                  <option value="Barbados">Barbados</option>
                                  <option value="Belarus">Belarus</option>
                                  <option value="Belgium">Belgium</option>
                                  <option value="Belize">Belize</option>
                                  <option value="Benin">Benin</option>
                                  <option value="Bermuda">Bermuda</option>
                                  <option value="Bhutan">Bhutan</option>
                                  <option value="Bolivia">Bolivia</option>
                                  <option value="Bosnia and Herzegovina">
                                    Bosnia and Herzegovina
                                  </option>
                                  <option value="Botswana">Botswana</option>
                                  <option value="Bouvet Island">
                                    Bouvet Island
                                  </option>
                                  <option value="Brazil">Brazil</option>
                                  <option value="British Indian Ocean Territory">
                                    British Indian Ocean Territory
                                  </option>
                                  <option value="Brunei Darussalam">
                                    Brunei Darussalam
                                  </option>
                                  <option value="Bulgaria">Bulgaria</option>
                                  <option value="Burkina Faso">
                                    Burkina Faso
                                  </option>
                                  <option value="Burundi">Burundi</option>
                                  <option value="Cambodia">Cambodia</option>
                                  <option value="Cameroon">Cameroon</option>
                                  <option value="Canada">Canada</option>
                                  <option value="Cape Verde">Cape Verde</option>
                                  <option value="Cayman Islands">
                                    Cayman Islands
                                  </option>
                                  <option value="Central African Republic">
                                    Central African Republic
                                  </option>
                                  <option value="Chad">Chad</option>
                                  <option value="Chile">Chile</option>
                                  <option value="China">China</option>
                                  <option value="Christmas Island">
                                    Christmas Island
                                  </option>
                                  <option value="Cocos (Keeling) Islands">
                                    Cocos (Keeling) Islands
                                  </option>
                                  <option value="Colombia">Colombia</option>
                                  <option value="Comoros">Comoros</option>
                                  <option value="Congo">Congo</option>
                                  <option value="Congo, The Democratic Republic of The">
                                    Congo, The Democratic Republic of The
                                  </option>
                                  <option value="Cook Islands">
                                    Cook Islands
                                  </option>
                                  <option value="Costa Rica">Costa Rica</option>
                                  <option value="Cote D'ivoire">
                                    Cote D'ivoire
                                  </option>
                                  <option value="Croatia">Croatia</option>
                                  <option value="Cuba">Cuba</option>
                                  <option value="Cyprus">Cyprus</option>
                                  <option value="Czech Republic">
                                    Czech Republic
                                  </option>
                                  <option value="Denmark">Denmark</option>
                                  <option value="Djibouti">Djibouti</option>
                                  <option value="Dominica">Dominica</option>
                                  <option value="Dominican Republic">
                                    Dominican Republic
                                  </option>
                                  <option value="Ecuador">Ecuador</option>
                                  <option value="Egypt">Egypt</option>
                                  <option value="El Salvador">
                                    El Salvador
                                  </option>
                                  <option value="Equatorial Guinea">
                                    Equatorial Guinea
                                  </option>
                                  <option value="Eritrea">Eritrea</option>
                                  <option value="Estonia">Estonia</option>
                                  <option value="Ethiopia">Ethiopia</option>
                                  <option value="Falkland Islands (Malvinas)">
                                    Falkland Islands (Malvinas)
                                  </option>
                                  <option value="Faroe Islands">
                                    Faroe Islands
                                  </option>
                                  <option value="Fiji">Fiji</option>
                                  <option value="Finland">Finland</option>
                                  <option value="France">France</option>
                                  <option value="French Guiana">
                                    French Guiana
                                  </option>
                                  <option value="French Polynesia">
                                    French Polynesia
                                  </option>
                                  <option value="French Southern Territories">
                                    French Southern Territories
                                  </option>
                                  <option value="Gabon">Gabon</option>
                                  <option value="Gambia">Gambia</option>
                                  <option value="Georgia">Georgia</option>
                                  <option value="Germany">Germany</option>
                                  <option value="Ghana">Ghana</option>
                                  <option value="Gibraltar">Gibraltar</option>
                                  <option value="Greece">Greece</option>
                                  <option value="Greenland">Greenland</option>
                                  <option value="Grenada">Grenada</option>
                                  <option value="Guadeloupe">Guadeloupe</option>
                                  <option value="Guam">Guam</option>
                                  <option value="Guatemala">Guatemala</option>
                                  <option value="Guernsey">Guernsey</option>
                                  <option value="Guinea">Guinea</option>
                                  <option value="Guinea-bissau">
                                    Guinea-bissau
                                  </option>
                                  <option value="Guyana">Guyana</option>
                                  <option value="Haiti">Haiti</option>
                                  <option value="Heard Island and Mcdonald Islands">
                                    Heard Island and Mcdonald Islands
                                  </option>
                                  <option value="Holy See (Vatican City State)">
                                    Holy See (Vatican City State)
                                  </option>
                                  <option value="Honduras">Honduras</option>
                                  <option value="Hong Kong">Hong Kong</option>
                                  <option value="Hungary">Hungary</option>
                                  <option value="Iceland">Iceland</option>
                                  <option value="IN">India</option>
                                  <option value="Indonesia">Indonesia</option>
                                  <option value="Iran, Islamic Republic of">
                                    Iran, Islamic Republic of
                                  </option>
                                  <option value="Iraq">Iraq</option>
                                  <option value="Ireland">Ireland</option>
                                  <option value="Isle of Man">
                                    Isle of Man
                                  </option>
                                  <option value="Israel">Israel</option>
                                  <option value="Italy">Italy</option>
                                  <option value="Jamaica">Jamaica</option>
                                  <option value="Japan">Japan</option>
                                  <option value="Jersey">Jersey</option>
                                  <option value="Jordan">Jordan</option>
                                  <option value="Kazakhstan">Kazakhstan</option>
                                  <option value="Kenya">Kenya</option>
                                  <option value="Kiribati">Kiribati</option>
                                  <option value="Korea, Democratic People's Republic of">
                                    Korea, Democratic People's Republic of
                                  </option>
                                  <option value="Korea, Republic of">
                                    Korea, Republic of
                                  </option>
                                  <option value="Kuwait">Kuwait</option>
                                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                                  <option value="Lao People's Democratic Republic">
                                    Lao People's Democratic Republic
                                  </option>
                                  <option value="Latvia">Latvia</option>
                                  <option value="Lebanon">Lebanon</option>
                                  <option value="Lesotho">Lesotho</option>
                                  <option value="Liberia">Liberia</option>
                                  <option value="Libyan Arab Jamahiriya">
                                    Libyan Arab Jamahiriya
                                  </option>
                                  <option value="Liechtenstein">
                                    Liechtenstein
                                  </option>
                                  <option value="Lithuania">Lithuania</option>
                                  <option value="Luxembourg">Luxembourg</option>
                                  <option value="Macao">Macao</option>
                                  <option value="Macedonia, The Former Yugoslav Republic of">
                                    Macedonia, The Former Yugoslav Republic of
                                  </option>
                                  <option value="Madagascar">Madagascar</option>
                                  <option value="Malawi">Malawi</option>
                                  <option value="Malaysia">Malaysia</option>
                                  <option value="Maldives">Maldives</option>
                                  <option value="Mali">Mali</option>
                                  <option value="Malta">Malta</option>
                                  <option value="Marshall Islands">
                                    Marshall Islands
                                  </option>
                                  <option value="Martinique">Martinique</option>
                                  <option value="Mauritania">Mauritania</option>
                                  <option value="Mauritius">Mauritius</option>
                                  <option value="Mayotte">Mayotte</option>
                                  <option value="Mexico">Mexico</option>
                                  <option value="Micronesia, Federated States of">
                                    Micronesia, Federated States of
                                  </option>
                                  <option value="Moldova, Republic of">
                                    Moldova, Republic of
                                  </option>
                                  <option value="Monaco">Monaco</option>
                                  <option value="Mongolia">Mongolia</option>
                                  <option value="Montenegro">Montenegro</option>
                                  <option value="Montserrat">Montserrat</option>
                                  <option value="Morocco">Morocco</option>
                                  <option value="Mozambique">Mozambique</option>
                                  <option value="Myanmar">Myanmar</option>
                                  <option value="Namibia">Namibia</option>
                                  <option value="Nauru">Nauru</option>
                                  <option value="Nepal">Nepal</option>
                                  <option value="Netherlands">
                                    Netherlands
                                  </option>
                                  <option value="Netherlands Antilles">
                                    Netherlands Antilles
                                  </option>
                                  <option value="New Caledonia">
                                    New Caledonia
                                  </option>
                                  <option value="New Zealand">
                                    New Zealand
                                  </option>
                                  <option value="Nicaragua">Nicaragua</option>
                                  <option value="Niger">Niger</option>
                                  <option value="Nigeria">Nigeria</option>
                                  <option value="Niue">Niue</option>
                                  <option value="Norfolk Island">
                                    Norfolk Island
                                  </option>
                                  <option value="Northern Mariana Islands">
                                    Northern Mariana Islands
                                  </option>
                                  <option value="Norway">Norway</option>
                                  <option value="Oman">Oman</option>
                                  <option value="Pakistan">Pakistan</option>
                                  <option value="Palau">Palau</option>
                                  <option value="Palestinian Territory, Occupied">
                                    Palestinian Territory, Occupied
                                  </option>
                                  <option value="Panama">Panama</option>
                                  <option value="Papua New Guinea">
                                    Papua New Guinea
                                  </option>
                                  <option value="Paraguay">Paraguay</option>
                                  <option value="Peru">Peru</option>
                                  <option value="Philippines">
                                    Philippines
                                  </option>
                                  <option value="Pitcairn">Pitcairn</option>
                                  <option value="Poland">Poland</option>
                                  <option value="Portugal">Portugal</option>
                                  <option value="Puerto Rico">
                                    Puerto Rico
                                  </option>
                                  <option value="Qatar">Qatar</option>
                                  <option value="Reunion">Reunion</option>
                                  <option value="Romania">Romania</option>
                                  <option value="Russian Federation">
                                    Russian Federation
                                  </option>
                                  <option value="Rwanda">Rwanda</option>
                                  <option value="Saint Helena">
                                    Saint Helena
                                  </option>
                                  <option value="Saint Kitts and Nevis">
                                    Saint Kitts and Nevis
                                  </option>
                                  <option value="Saint Lucia">
                                    Saint Lucia
                                  </option>
                                  <option value="Saint Pierre and Miquelon">
                                    Saint Pierre and Miquelon
                                  </option>
                                  <option value="Saint Vincent and The Grenadines">
                                    Saint Vincent and The Grenadines
                                  </option>
                                  <option value="Samoa">Samoa</option>
                                  <option value="San Marino">San Marino</option>
                                  <option value="Sao Tome and Principe">
                                    Sao Tome and Principe
                                  </option>
                                  <option value="Saudi Arabia">
                                    Saudi Arabia
                                  </option>
                                  <option value="Senegal">Senegal</option>
                                  <option value="Serbia">Serbia</option>
                                  <option value="Seychelles">Seychelles</option>
                                  <option value="Sierra Leone">
                                    Sierra Leone
                                  </option>
                                  <option value="Singapore">Singapore</option>
                                  <option value="Slovakia">Slovakia</option>
                                  <option value="Slovenia">Slovenia</option>
                                  <option value="Solomon Islands">
                                    Solomon Islands
                                  </option>
                                  <option value="Somalia">Somalia</option>
                                  <option value="South Africa">
                                    South Africa
                                  </option>
                                  <option value="South Georgia and The South Sandwich Islands">
                                    South Georgia and The South Sandwich Islands
                                  </option>
                                  <option value="Spain">Spain</option>
                                  <option value="Sri Lanka">Sri Lanka</option>
                                  <option value="Sudan">Sudan</option>
                                  <option value="Suriname">Suriname</option>
                                  <option value="Svalbard and Jan Mayen">
                                    Svalbard and Jan Mayen
                                  </option>
                                  <option value="Swaziland">Swaziland</option>
                                  <option value="Sweden">Sweden</option>
                                  <option value="Switzerland">
                                    Switzerland
                                  </option>
                                  <option value="Syrian Arab Republic">
                                    Syrian Arab Republic
                                  </option>
                                  <option value="Taiwan">Taiwan</option>
                                  <option value="Tajikistan">Tajikistan</option>
                                  <option value="Tanzania, United Republic of">
                                    Tanzania, United Republic of
                                  </option>
                                  <option value="Thailand">Thailand</option>
                                  <option value="Timor-leste">
                                    Timor-leste
                                  </option>
                                  <option value="Togo">Togo</option>
                                  <option value="Tokelau">Tokelau</option>
                                  <option value="Tonga">Tonga</option>
                                  <option value="Trinidad and Tobago">
                                    Trinidad and Tobago
                                  </option>
                                  <option value="Tunisia">Tunisia</option>
                                  <option value="Turkey">Turkey</option>
                                  <option value="Turkmenistan">
                                    Turkmenistan
                                  </option>
                                  <option value="Turks and Caicos Islands">
                                    Turks and Caicos Islands
                                  </option>
                                  <option value="Tuvalu">Tuvalu</option>
                                  <option value="Uganda">Uganda</option>
                                  <option value="Ukraine">Ukraine</option>
                                  <option value="United Arab Emirates">
                                    United Arab Emirates
                                  </option>
                                  <option value="United Kingdom">
                                    United Kingdom
                                  </option>
                                  <option value="United States">
                                    United States
                                  </option>
                                  <option value="United States Minor Outlying Islands">
                                    United States Minor Outlying Islands
                                  </option>
                                  <option value="Uruguay">Uruguay</option>
                                  <option value="Uzbekistan">Uzbekistan</option>
                                  <option value="Vanuatu">Vanuatu</option>
                                  <option value="Venezuela">Venezuela</option>
                                  <option value="Viet Nam">Viet Nam</option>
                                  <option value="Virgin Islands, British">
                                    Virgin Islands, British
                                  </option>
                                  <option value="Virgin Islands, U.S.">
                                    Virgin Islands, U.S.
                                  </option>
                                  <option value="Wallis and Futuna">
                                    Wallis and Futuna
                                  </option>
                                  <option value="Western Sahara">
                                    Western Sahara
                                  </option>
                                  <option value="Yemen">Yemen</option>
                                  <option value="Zambia">Zambia</option>
                                  <option value="Zimbabwe">Zimbabwe</option>
                                </AvField>
                              </div>
                            </div>

                            {/* <div className="col-md-6 mt-5">
                              <AvGroup className="phone phone1">
                                <Label
                                  for="phone"
                                  style={{ marginTop: "-2.25em" }}
                                >
                                  Phone Number
                                </Label>
                                <div className="form--control">
                                  <PhoneInput
                                    name="phone"
                                    id="phone"
                                    country={"mt"}
                                    defaultCountry={"mt"}
                                    defaultCountryValue="123-456-7890"
                                    placeholder="Enter Phone Number"
                                    value={
                                      userList?.phone ? userList.phone : "+356"
                                    }
                                    onChange={handlePhoneChange}
                                    disabled
                                  />
                                </div>
                              </AvGroup>
                            </div> */}
                            <div className="col-md-6">
                              <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                                <div>
                                  <label for="Phone" className="form-label">
                                    {t('userProfile.profilePage.phoneNumber')}
                                  </label>
                                </div>
                                {/* <AvField name="phone"  required> */}
                                <div> <PhoneInput
                                  placeholder="Enter phone number"
                                  value={value}
                                  disabled={!isEditable || !!userList?.phone}
                                  // onChange={setValue}
                                  onChange={(phone) => setValue(phone)}
                                  country="in"
                                  className="form--control3"
                                  international={true}
                                  // enableSearch={true}
                                  countrySelectProps={{
                                    style: {
                                      '--PhoneInputCountrySelectArrow-color': '#666',
                                      '--PhoneInputCountryFlag-height': '18px',

                                    }
                                  }}
                                /></div>

                                {/* </AvField> */}



                                {/* <PhoneInput
                                  placeholder="Enter phone number"
                                  value={value}
                                  onChange={setValue}
                                  defaultCountry="IN"  // Set default to India based on your location
                                /> */}
                                {/* <AvField
                                  name="phone"
                                  id="phone"
                                  className="form-control form--control3 style-two "
                                  placeholder="Enter Phone Number"
                                  required
                                  value={userList ? userList.phone : ""}
                                   disabled={!isEditable || !!userList?.phone}
                                  // disabled={!!userList.phone}
                                  validate={{
                                    required: { value: true, errorMessage: "Phone number is required" },
                                    // pattern: {
                                    //   value: /^\+91[6-9]\d{9}$/,
                                    //   errorMessage: "Enter a valid phone number starting with +91"
                                    // }
                                  }}
                                // disabled
                                /> */}
                              </div>
                            </div>
                            <div className="col text-left" style={{ marginTop: "20px" }}>
                              <button className="cstm_btn2  btn--round active mt-1">
                                {t('userProfile.profilePage.save')}
                              </button>
                            </div>

                        

                            {/* <div className="col-12">
                              <h5
                                className="promotional-lable"
                                style={{ color: "white" }}
                              >
                                {" "}
                                Receive marketing and promotional materials via
                                all channels or only via.
                              </h5>
                            </div> */}
                            {/* <div className="d-flex promotional-data">
                              <div className="col-12">
                                <div className="row mt-3">
                                  <div className="col-md-2 mt-1 d-flex align-items-center">
                                    <AvField
                                      type="checkbox"
                                      name="email_promotion"
                                      checked={userList.email_promotion}
                                    />
                                    <label
                                      htmlFor="Email"
                                      className="form-label ms-2 mb-3"
                                    >
                                      Email
                                    </label>
                                  </div>
                                  <div className="col-md-2 mt-1 d-flex align-items-center">
                                    <AvField
                                      type="checkbox"
                                      name="phone_promotion"
                                      checked={userList.phone_promotion}
                                    />
                                    <label
                                      htmlFor="Phone"
                                      className="form-label ms-2 mb-3"
                                    >
                                      Phone
                                    </label>
                                  </div>
                                  <div className="col-md-2 mt-1 d-flex align-items-center">
                                    <AvField
                                      type="checkbox"
                                      name="post_promotion"
                                      checked={userList.post_promotion}
                                    />
                                    <label
                                      htmlFor="Post"
                                      className="form-label ms-2 mb-3"
                                    >
                                      Post
                                    </label>
                                  </div>
                                  <div className="col-md-2 mt-1 d-flex align-items-center">
                                    <AvField
                                      type="checkbox"
                                      name="sms_promotion"
                                      checked={userList.sms_promotion}
                                    />
                                    <label
                                      htmlFor="SMS"
                                      className="form-label ms-2 mb-3"
                                    >
                                      SMS
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div> */}

                            {/* <div className="col-12">
                              <div className="form-group">
                                <label className="form-label" for="about">
                                  About You
                                </label>
                                <AvField
                                  required
                                  errorMessage="Please provide information about yourself."
                                  className="form-control form--control style-two pt-2"
                                  type="textarea"
                                  name="basic_info"
                                  placeholder="About You"
                                  value={userList ? userList.basic_info : ""}
                                />
                              </div>
                            </div> */}

                          </Row>
                        </AvForm>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>
        </div>
      }
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.Auth;
  return user;
};
export default connect(mapStateToProps)(EditAccounts);
